export default "__VITE_ASSET__JxFDLbqO__"